import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./store/reducers/auth";
import companyReducer from "./store/reducers/company";
// ...

export const store = configureStore({
  reducer: {
    auth: authReducer,
    company: companyReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
